(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    if (!window.__maisonDamasAccordionTrackingInitialized) {
    window.__maisonDamasAccordionTrackingInitialized = true;

    const pendingAccordionToggles = new WeakSet();

    const pushAccordionOpen = (summary) => {
      const accordionKey = summary.dataset.accordionKey;
      const eventKey = accordionKey.replace(/-/g, '_');

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: `accordion_open_${eventKey}`,
        accordion_id: summary.id,
        accordion_name: accordionKey,
        accordion_label: summary.dataset.accordionLabel,
        product_handle: summary.dataset.productHandle || '',
        product_name: summary.dataset.productTitle || '',
        source_page_type: 'product',
        source_page_path: window.location.pathname
      });
    };

    const bindAccordionTracking = (root) => {
      root.querySelectorAll('details').forEach((details) => {
        const summary = details.querySelector(
          ':scope > summary[data-track-accordion]'
        );

        if (
          !summary ||
          details.dataset.accordionTrackingBound === 'true'
        ) {
          return;
        }

        details.dataset.accordionTrackingBound = 'true';

        details.addEventListener('toggle', () => {
          if (!pendingAccordionToggles.has(details)) return;

          pendingAccordionToggles.delete(details);

          if (details.open) {
            pushAccordionOpen(summary);
          }
        });
      });
    };

    bindAccordionTracking(document);

    document.addEventListener('click', (event) => {
      const summary = event.target.closest(
        'summary[data-track-accordion]'
      );

      if (!summary) return;

      const details = summary.closest('details');

      if (!details) return;

      pendingAccordionToggles.add(details);

      window.setTimeout(() => {
        pendingAccordionToggles.delete(details);
      }, 1500);
    }, true);

    document.addEventListener('shopify:section:load', (event) => {
      bindAccordionTracking(event.target);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
